module.exports = __webpack_public_path__ + "static/media/fly0256.74243819.webp";